import React, { useState, useEffect } from "react";
import { Button, TextField, IconButton } from "@mui/material";
import Swal from "sweetalert2";
import { Delete, Edit } from "@mui/icons-material";
import {
  createAnnouncement,
  getAnnouncements,
  updateAnnouncement,
  deleteAnnouncement,
} from "../../services/getAdminApi";

const CreateAnnouncement = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [formData, setFormData] = useState({ title: "", description: "" });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const fetchAnnouncements = async () => {
    try {
      const response = await getAnnouncements();
      setAnnouncements(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      Swal.fire("Error", "Failed to fetch announcements", "error");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    if (!formData.title || !formData.description) {
      Swal.fire("Validation Error", "Please fill all required fields", "error");
      return;
    }

    try {
      if (editingId !== null) {
        await updateAnnouncement(editingId, formData);
        Swal.fire("Success", "Announcement updated successfully", "success");
      } else {
        await createAnnouncement(formData);
        Swal.fire("Success", "Announcement created successfully", "success");
      }

      setFormData({ title: "", description: "" });
      setEditingId(null);
      fetchAnnouncements();
    } catch (error) {
      Swal.fire("Error", "Failed to save announcement", "error");
    }
  };

  const handleEdit = (announcement) => {
    setEditingId(announcement.id);
    setFormData({
      title: announcement.title,
      description: announcement.description,
    });
  };

  const handleDelete = async (id) => {
    try {
      await deleteAnnouncement(id);
      Swal.fire("Success", "Announcement deleted successfully", "success");
      fetchAnnouncements();
    } catch (error) {
      Swal.fire("Error", "Failed to delete announcement", "error");
    }
  };

  return (
    <div>
      <div className="dashboard-heading-div">
        <p>Manage Announcements</p>
      </div>
      <div className="editing-container">
        <h2 className="editing-container-heading">
          {editingId !== null ? "Edit Announcement" : "Create Announcement"}
        </h2>
        <div className="editing-container-form">
          <div className="editing-container-input-div">
            <label>Title:</label>
            <input
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
              placeholder="Enter Title"
            />
          </div>

          <div className="editing-container-input-div">
            <label>Description:</label>
            <input
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              required
              placeholder="Enter Description"/>
          </div>
        </div>
        <button className="save-btn" onClick={handleSave}>
            {editingId !== null ? "Update" : "SAVE"} <i className="bx bx-send"></i>
        </button>
      </div>

      <div className="table-container-registered-announcements">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {announcements.map((announcement) => (
              <tr key={announcement.id}>
                <td>{announcement.title}</td>
                <td>{announcement.description}</td>
                <td>
                  <IconButton
                    color="primary"
                    onClick={() => handleEdit(announcement)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    color="secondary"
                    onClick={() => handleDelete(announcement.id)}
                  >
                    <Delete />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CreateAnnouncement;
